export const entityToMap = (entity: any, map: Map<string, any>) => {
  map.set(entity.id, entity);
  return entity.id;
};

export const getArrayFromMap = (map: Map<string, any>) =>
  Array.from(map.values());
